module.exports = __webpack_public_path__ + "media/images/bg/headers/geta-87c0bf368e5ae98b849d375ac9c17472.png";